import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Image from 'components/Image';

import useAdBanner from 'hooks/useAdBanner';

import { sendEvent } from 'lib/gtag';

import { useUser } from 'providers/UserProvider';

import SignInOptionsContainer from './SignInOptionsContainer';

const HighlightedStores = dynamic(
  () => import('components/Sidebar/HighlightedStores/V2')
);

const Sidebar = ({ featuredStores = [], gaEventCategory, sidebarAds }) => {
  const { isLoggedIn, loadingLoggedInUser } = useUser();
  const { getAdBannerWithHigherVisibilityPriority } = useAdBanner();

  const ad = useMemo(
    () => getAdBannerWithHigherVisibilityPriority(sidebarAds),
    [sidebarAds, getAdBannerWithHigherVisibilityPriority]
  );

  const onAdClick = () => {
    sendEvent({
      action: 'offer_ads_banner',
      category: gaEventCategory,
    });
  };

  return (
    <aside className="sticky top-[132px] flex h-fit max-w-80 flex-col gap-8">
      {!isLoggedIn && !loadingLoggedInUser && <SignInOptionsContainer />}
      {featuredStores.length > 0 && (
        <HighlightedStores stores={featuredStores} />
      )}
      {ad && (
        <a
          className="flex rounded-4 border border-neutral-high-200 dark:border-neutral-low-200"
          href={ad.url}
          rel="noopener noreferrer"
          target="_blank"
          onClick={onAdClick}
        >
          <Image
            alt={ad.description}
            className="rounded-4"
            height={100}
            src={ad.image}
            width={320}
          />
        </a>
      )}
    </aside>
  );
};

Sidebar.propTypes = {
  featuredStores: PropTypes.arrayOf(
    PropTypes.shape({
      storeSlug: PropTypes.string,
      storeName: PropTypes.string,
    })
  ),
  gaEventCategory: PropTypes.string.isRequired,
  sidebarAds: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      visibility: PropTypes.string.isRequired,
    })
  ),
};

export default Sidebar;
